import CryptoJS from "crypto-js";

export const encrypt = (args) => {
  try {
    if (args) {
      const ciphertext = CryptoJS.AES.encrypt(args, process.env.REACT_APP_SECRETKEY).toString();
      return encodeURIComponent(ciphertext);
    }
    return null;
  } catch (error) {
    return null;
  }
};

export const decrypt = (args) => {
  try {
    let plaintext = '';
    if (args) {
      const ciphertext = decodeURIComponent(args);
      const bytes = CryptoJS.AES.decrypt(ciphertext, process.env.REACT_APP_SECRETKEY);
      if (bytes.sigBytes > 0) {
        plaintext = bytes.toString(CryptoJS.enc.Utf8);
      } else {
        plaintext = '';
      }
    }
    return plaintext;
  } catch (error) {
    return null;
  }
};